export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";